import Reveal from "@/components/Reveal";

export default function PageHero({ eyebrow, title, description, accent = "blue" }) {
  const dot =
    accent === "red" ? "bg-saavi-red" : accent === "green" ? "bg-saavi-green" : "bg-saavi-blue";
  const blob =
    accent === "red" ? "bg-saavi-red/25" : accent === "green" ? "bg-saavi-green/25" : "bg-saavi-blue/25";
  return (
    <section className="relative border-b border-border overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" aria-hidden="true" />
      <div aria-hidden="true" className={`blob ${blob} w-[420px] h-[420px] top-[-160px] right-[-100px]`} />
      <div className="container-saavi relative pt-16 pb-20 md:pt-24 md:pb-28">
        <Reveal variant="fade-up">
          <div className="flex items-center gap-2 font-mono-overline text-muted-foreground mb-6">
            <span className={`inline-block h-1.5 w-1.5 rounded-full ${dot} pulse-dot`} />
            {eyebrow}
          </div>
        </Reveal>
        <Reveal variant="blur-in" delay={120}>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl max-w-4xl">{title}</h1>
        </Reveal>
        {description && (
          <Reveal variant="fade-up" delay={260}>
            <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">{description}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
